import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-flag-fill",
  "use": "svg-flag-fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-flag-fill\"><path d=\"M880 304.992h-256V192c0-17.696-14.304-32-32-32H184V120a8 8 0 0 0-8-8H120a8 8 0 0 0-8 8v784c0 4.384 3.584 8 8 8H176a8 8 0 0 0 8-8V640h248v112.992c0 17.696 14.304 32 32 32h416c17.696 0 32-14.304 32-32v-416c0-17.696-14.304-32-32-32z\" p-id=\"2056\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol